import React from 'react';

import ExternalLink from 'src/components/common/external-link';
import { ReactComponent as EmailIcon } from 'src/assets/icons/email.svg';
import { ReactComponent as GlobeIcon } from 'src/assets/icons/globe.svg';
import { ReactComponent as MapPinIcon } from 'src/assets/icons/map-pin.svg';
import { ReactComponent as PhoneIcon } from 'src/assets/icons/phone.svg';

import type { CompanyContactsProps } from './company-contacts.props';

import './company-contacts.scss';

const CompanyContacts = ({ address, email, phone, website }: CompanyContactsProps) => {
  return (
    <ul className="company-contacts">
      <li className="company-contacts__item">
        <MapPinIcon className="company-contacts__item-icon" />
        <span className="company-contacts__item-text">כתובת: {address}</span>
      </li>
      <li className="company-contacts__item">
        <PhoneIcon className="company-contacts__item-icon" />
        <span className="company-contacts__item-text">
          whatsapp / טלפון:{' '}
          <ExternalLink className="company-contacts__link" href={`tel:${phone}`}>
            {phone.replace(/(\d{3})(\d{7})/, '$1-$2')}
          </ExternalLink>
        </span>
      </li>
      <li className="company-contacts__item">
        <EmailIcon className="company-contacts__item-icon" />
        <span className="company-contacts__item-text">
          אמייל:{' '}
          <ExternalLink className="company-contacts__link" href={`mailto:${email}`}>
            {email}
          </ExternalLink>
        </span>
      </li>
      <li className="company-contacts__item">
        <GlobeIcon className="company-contacts__item-icon" />
        <span className="company-contacts__item-text">
          אתר אינטרנט:{' '}
          <ExternalLink className="company-contacts__link" href={website}>
            {website.replace(/^https?:\/\//, '').replace(/\/$/, '')}
          </ExternalLink>
        </span>
      </li>
    </ul>
  );
};

export default CompanyContacts;
